<template>
<div class="tooltip-modal" id="tooltip-window">
    <span><b>{{tooltip_data.title}}</b><div class="tooltip-close" @click="emit('close-modal')"/></span>
    <span v-if="tooltip_data.desc">{{tooltip_data.desc}}<br></span>
    <span v-if="tooltip_data.score"><b>Score: </b>{{tooltip_data.score}}<br></span>
    <span v-if="tooltip_data.link">
        <span v-for="link in tooltip_data.link">The <b>{{link.type}}</b> can be found at <a :href="link.url" target="_blank">this link</a>.<br></span>
    </span><br>
</div>
</template>

<script setup lang="js">
import { watch, onMounted } from 'vue';

const props = defineProps({
    tooltip_data: Object,
})

const emit = defineEmits(['close-modal']);

onMounted(() => {
    readjustTooltip();
})

watch(() => [props?.tooltip_data.left, props?.tooltip_data.right], () => {
    readjustTooltip();
})

const readjustTooltip = () => {
    if (props?.tooltip_data.left) {
        document.getElementById("tooltip-window").style.left = (props?.tooltip_data.left) + 'px';
        document.getElementById("tooltip-window").style.right = 'auto';
    }
        
    if (props?.tooltip_data.right) {
        document.getElementById("tooltip-window").style.right = (props?.tooltip_data.right) + 'px';
        document.getElementById("tooltip-window").style.left = 'auto';
    }
        
    if (props?.tooltip_data.top)
        document.getElementById("tooltip-window").style.top = (props?.tooltip_data.top + 40) + 'px';
}

</script>

<style scoped>

.tooltip-modal {
    background-color: rgba(227,227,227,0.95);
    border: var(--dark-grey) solid 2px;
    width: fit-content;
    max-width: 40rem;
    height: fit-content;
    color: black;
    padding: 8px;
    position: absolute;
    z-index: 1000;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin-right: 8px;
    font-size: var(--font-500);
}

.tooltip-close {
    float:right;
    position: relative;
    width: 15px;
    height: 15px;
    transform: translateY(25%);
    cursor: pointer;
}

.tooltip-close::before,
.tooltip-close::after {
    position: absolute;
    content: '';
    width: 100%;
    height: 3px; /* Thickness of the X, feel free to play with this */
    background-color: black;
}

.tooltip-close::before {
    transform: rotate(45deg);
}

.tooltip-close::after {
    transform: rotate(-45deg);
}

</style>